import type { BiometryResponse } from '~/utils/customer-register/Biometry'
import { useMutation } from '@tanstack/vue-query'
import { queryClient, queryKeys } from '~/queryClient'
import { cancelCustomerBiometry } from '~/services-v2/contract-formalization-api/contract-formalization-api'

export default function useCustomerBiometryCancel(projectId: Ref<string>) {
  const mutationFn = async () => {
    return cancelCustomerBiometry(projectId.value)
  }

  return useMutation({
    mutationFn,
    mutationKey: queryKeys.CONTRACT_BIOMETRY.CANCEL,
    retry: 3,
    retryDelay: 1000,
    onSuccess: () => {
      queryClient.setQueryData<BiometryResponse>(queryKeys.CONTRACT_BIOMETRY.DATA(projectId.value), (oldData) => {
        if (!oldData)
          return oldData

        return {
          ...oldData,
          approval: 'waiting',
          biometry: { ...oldData.biometry, status: 'waiting' },
          contract: { ...oldData.contract, status: 'waiting' },
          status: 'waiting_to_start',
        }
      })

      queryClient.invalidateQueries({
        queryKey: queryKeys.CONTRACT_BIOMETRY.DATA(projectId.value),
      })
    },
  })
}
